import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { accessPermission } from '@/modules/user/permissions'
import { IS_DOCTOR } from '@/modules/user/accessTokens'

const PROFILE_PREFIX = 'cabinet:profile'
const STAFF_PROFILE_PREFIX = 'staff:profile'
export const SETTINGS_BASE = 'cabinet:settings'
export const NOTIFICATIONS_BASE = 'cabinet:notifications'
export const STAFF_NOTIFICATIONS_BASE = 'cabinet:notifications'
const p = (name: string) => PROFILE_PREFIX + ':' + name
const pStaff = (name: string) => STAFF_PROFILE_PREFIX + ':' + name
const s = (name: string) => SETTINGS_BASE + ':' + name
const n = (name: string) => NOTIFICATIONS_BASE + ':' + name
const nStaff = (name: string) => STAFF_NOTIFICATIONS_BASE + ':' + name

export const PROFILE_VIEW_NAME = p('view')
export const STAFF_PROFILE_VIEW_NAME = pStaff('view')
export const SECURITY_VIEW_NAME = s('view')
export const NOTIFICATIONS_SETTINGS_VIEW_NAME = s('notifications')
export const NOTIFICATIONS_SETTINGS_TELEGRAM_VIEW_NAME = s(
  'notifications:telegram'
)
export const NOTIFICATIONS_VIEW_NAME = n('view')
export const STAFF_NOTIFICATIONS_VIEW_NAME = nStaff('view')

const ProfileView = () => import('./views/Profile.vue')
const SecurityView = () => import('./views/Security.vue')
const NotificationsView = () => import('./views/Notifications.vue')
const NotificationsSettingsView = () =>
  import('./views/NotificationsSettings.vue')
const NotificationTelegramSubscriptionView = () =>
  import('./views/NotificationTelegramSubscription.vue')

const BASE_MODEL_PATH = 'profile/'
const BASE_SETTINGS_MODEL_PATH = 'settings/'
const BASE_NOTIFICATIONS_MODEL_PATH = 'notifications/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global
  return [
    route('', ProfileView, PROFILE_VIEW_NAME, {
      meta: {
        title: () => $t('Manage your profile'),
      },
    }),
  ]
}
export function createStaffRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global
  return [
    route('', ProfileView, STAFF_PROFILE_VIEW_NAME, {
      meta: {
        title: () => $t('Manage your profile'),
      },
    }),
  ]
}

export function createNotificationsRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global
  const { app } = options
  app.config.globalProperties.$router_notifications_view_name =
    NOTIFICATIONS_VIEW_NAME

  return [
    route('', NotificationsView, NOTIFICATIONS_VIEW_NAME, {
      meta: {
        title: () => $t('My notifications'),
      },
    }),
  ]
}
export function createSettingsRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global
  const { app } = options
  app.config.globalProperties.$router_notifications_settings_telegram_view_name =
    NOTIFICATIONS_SETTINGS_TELEGRAM_VIEW_NAME
  return [
    route('security/', SecurityView, SECURITY_VIEW_NAME, {
      meta: {
        title: () => $t('Security'),
        ...accessPermission([IS_DOCTOR], options),
      },
    }),
    route(
      'notifications/',
      NotificationsSettingsView,
      NOTIFICATIONS_SETTINGS_VIEW_NAME,
      {
        meta: {
          title: () => $t('Setting up notifications'),
        },
      }
    ),
    route(
      'telegram-subscription/',
      NotificationTelegramSubscriptionView,
      NOTIFICATIONS_SETTINGS_TELEGRAM_VIEW_NAME,
      {
        meta: {
          title: () => $t('Telegram bot subscription'),
        },
      }
    ),
  ]
}

export {
  BASE_MODEL_PATH,
  BASE_SETTINGS_MODEL_PATH,
  BASE_NOTIFICATIONS_MODEL_PATH,
}
